export default __webpack_public_path__ + "vision-safety-alerts-drawing-thumbnail-480-0678a833fdb577dd4281185d917bba58.png";